<template>
    <div>
        <div class="header" :style="bjStyle" >
            <img src="../imgs/banner_cn.png" class="header-img" v-if="locale=='ch'">
            <img src="../imgs/sectop.png" class="header-img" v-if="locale=='en'">
        </div>
        <div class="content">
            <div class="leftPad">
                <span @click="goHome" class="idx_title">{{ $t("sIndex.index") }}</span><span class="fx">></span><span class="s_title">{{ $t("sIndex.sign") }}</span>
                <span :class="{ch_mg:locale=='ch',en_mg:locale=='en'}">
                    <span>{{locale=="en"?"Welcome":"欢迎"}}</span>
                <span style="padding-left:5px;padding-right:5px">{{user.uName==null||user.uName==''?(locale=='en'?"":"您"):user.uName.length>12?uName.subStr(0,12)+"...":user.uName}}</span>
                <span>{{locale=="en"?"to register":"登录报名系统"}}</span>
                </span>
            </div>
        </div>
        <div class="line"></div>
        <div class="content">
            <div class="step">
                <span v-bind:class="{ active:activeTab=='0' }">{{ $t("sIndex.step1") }}</span><span>---</span><span v-bind:class="{ active:activeTab=='1' }">{{ $t("sIndex.step2") }}</span><span>---</span><span v-bind:class="{ active:activeTab=='2' }">{{ $t("sIndex.step3") }}</span><span>---</span><span v-bind:class="{ active:activeTab=='3' }" v-if="locale=='ch'">{{ $t("sIndex.step4") }}</span><span v-if="locale=='ch'">---</span><span v-bind:class="{ active:activeTab=='4' }">{{ $t("sIndex.step5") }}</span><span>---</span><span v-bind:class="{ active:activeTab=='5' }">{{ $t("sIndex.step6") }}</span>
            </div>
            <div style="padding-left:80px">
                <router-view></router-view>
            </div>
        </div>
        <div class="footer">
            <!-- <img src="" width="100%" height="100%"> -->
        </div>
    </div>
</template>
<script>
export default {
    data() {
            return {
                homePath: '',
                user: {},
                locale: '',
                banner:'',

            }
        },
        computed: {
            activeTab() {
                let params;
                let tab = 0;
                let fullPath = this.$route.fullPath;
                if (fullPath.indexOf('sign')) {
                    params = fullPath.split('\/sign\/')[1];
                } else if (fullPath.indexOf('order')) {
                    params = fullPath.split('\/order\/')[1];
                }
                switch (params) {
                    case 'add/0':
                        tab = 0;
                        break;
                    case 'add/1':
                        tab = 0;
                        break;
                    case 'apply/0':
                        tab = 1;
                        break;
                    case 'apply/1':
                        tab = 1;
                        break;
                    case 'hotel/0':
                        tab = 2;
                        break;
                    case 'invoice/0':
                        tab = 3;
                        break;
                    case 'hotel/1':
                        tab = 2;
                        break;
                    case 'hotel/2':
                        tab = 2;
                        break;
                    case 'invoice/1':
                        tab = 3;
                        break;
                    case 'morder':
                        tab = 4;
                        break;
                    case 'pay':
                        tab = 5;
                        break;
                }
                return tab;
            },
          bjStyle(){
            return {
              'background-image': `url(http://medicalcircle.cn/lib/tiantan/bj.jpg)`,
              'background-position': '0 0',
              'background-size': 'cover'
            }
          }
        },
        methods: {
            goHome() {
                //            console.log(this.homePath);
                if (localStorage.getItem('cid') == '1992') {
                    //window.location.href="http://101.200.234.55:8080/cimdr/index.html";

                    if(this.locale=='ch'){
                        window.location.href = "http://www.cimdr.com/cimdr/childPage.html";
                        // window.location.href = "http://101.200.234.55:8080/tiantan/#/home_en/2016";

                    }else{
                        window.location.href = "http://www.cimdr.com/cimdr/engchildPage.html";
                        // window.location.href = "http://101.200.234.55:8080/tiantan/#/home_en/2016";
                    }

                } else {
                  if(this.locale=='ch'){
                    this.$router.push("/home/2006");
                  }else{
                    this.$router.push("/home_en/2006");
                  }
                }

            }
        },
        watch:{
            $route(){
                console.log();
                this.locale = localStorage.getItem("locale");
            }
        },
        mounted() {
            let homePath = localStorage.getItem('homePath');
            this.user = JSON.parse(localStorage.getItem("user"));
            this.homePath = homePath;

            this.locale = localStorage.getItem("locale");
            console.log(this.locale);
            console.log( " sIndex.step1"+this.$t("sIndex.step1"));
        }
}
</script>
<style>
.ch_mg {
    color: #359ED8;
    font-size: 20px;
    font-weight: 500;
    margin-left: 480px
}

.en_mg {
    color: #359ED8;
    font-size: 20px;
    font-weight: 500;
    margin-left: 350px
}

.header {
    max-width: 1366px;
    margin: 0 auto;
}

.header-img {
    width: 1200px;
    height: 350px;
}

.content {
    width: 1050px;
    height: 100%;
    margin: 0 auto;
}

.leftPad {
    padding-left: 80px;
}

.active {
    color: #F39088;
}

.line {
    height: 1px;
    background-color: #999;
    margin-top: 5px;
    max-width: 1366px;
    margin-left: auto;
    margin-right: auto;
}

.step {
    padding: 10px 0 0 0;
    font-size: 18px;
    color: #000;
    font-weight: 500;
    padding-left: 80px;
}

.step span {
    padding-right: 25px
}

.idx_title {
    color: #000;
    font-size: 20px;
    font-weight: 600;
    cursor: pointer;
}

.s_title {
    color: #359ED8;
    font-size: 20px;
    font-weight: 500;
}

.welcome1 {
    color: #359ED8;
    font-size: 20px;
    font-weight: 500;
}

.welcome2 {
    color: #359ED8;
    font-size: 20px;
    font-weight: 500;
}

.fx {
    font-size: 20px;
    color: #000;
    padding: 0 5px;
    font-weight: 500;
}

.footer {
    margin-top: 50px;
    /*  width: 100%;
    height: 200px;
    margin-left: auto;
    margin-right: auto;
    max-width: 1366px;*/
}
</style>



// WEBPACK FOOTER //
// s_index.vue?2a0c144a